import EffectMod from "@/roc/effects/EffectMod";
import { Calc } from "@/roc/effects/EffectAmount";
class HappinessMod extends EffectMod {
    constructor(amount) {
        super(Calc.flat, amount);
    }
    apply(value) {
        return value + this.__amount;
    }
}
export default HappinessMod;
